var map = {
	"./pin-place-bed-alt.png": 324,
	"./pin-place-charging-station.png": 754,
	"./pin-place-chess-rook.png": 205,
	"./pin-place-gas-pump.png": 356,
	"./pin-place-utensils.png": 740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 759;